import { HttpErrorResponse } from '@angular/common/http';
import { Component, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { DropDownFilterSettings, MultiSelectComponent } from '@progress/kendo-angular-dropdowns';
import { Subject, Subscription, takeUntil } from 'rxjs';
import { BCMCLPUser, TeamCodes } from '../../../models/clpuser.model';
import { CMClub, CMClubResponse, CMSite, CMSiteListResponse } from '../../../models/cm-club-service.model';
import { IntDropDownItem, SimpleResponse, UserDD } from '../../../models/generic-response.model';
import { Membership, MemContactListDropDown, MemPolicyViolation, MemPolicyViolationListRequest, MemPolicyViolationResponse, REF_MemFeeType } from '../../../models/membership.model';
import { CMClubService } from '../../../services/cm-club.service';
import { MembershipService } from '../../../services/membership.service';
import { GlobalService } from '../../../services/shared/global.service';
import { LocalService } from '../../../services/shared/local.service';
import { UtilityService } from '../../../services/shared/utility.service';
import { TeamOfficeService } from '../../../services/team-office.service';
import { UserService } from '../../../services/user.service';
import { MatSort, Sort } from '@angular/material/sort';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { DatePipe } from '@angular/common';
import Swal from 'sweetalert2';
import { isNullOrUndefined } from 'util';

@Component({
    selector: 'app-mem-policy-violation',
    templateUrl: './mem-policy-violation.component.html',
    styleUrls: ['./mem-policy-violation.component.css']
})
export class MemPolicyViolationComponent {
    encryptedUser: string;
    user: BCMCLPUser;
    teamSub: Subscription;
    curTeam: TeamCodes = <TeamCodes>{};
    showSpinner: boolean;
    clubConfig: CMClub;
    sites: CMSite[];
    filterSettings: DropDownFilterSettings = {
        caseSensitive: false,
        operator: 'contains',
    };
    selectedSiteIDs = [];
    policyViolationForm: FormGroup;
    policyViolationList = [];
    feeTypeDD: REF_MemFeeType[];
    policyViolationID: number = 0;
    memPolicyViolation: MemPolicyViolation;
    memContact_dd: MemContactListDropDown[];
    memberShip: Membership;
    clpUsersDD: UserDD[];
    contactId: number = 0;
    private destroy$ = new Subject<void>();

    constructor(
        private localService: LocalService,
        private membershipService: MembershipService,
        public _localService: LocalService,
        private _globalService: GlobalService,
        private _router: Router,
        private _utilityService: UtilityService,
        private _teamOfficeService: TeamOfficeService,
        private userService: UserService,
        private fb: FormBuilder,
        private clubService: CMClubService,
        private datePipe: DatePipe,
        private _route: ActivatedRoute
    ) {
        this.localService.setShowMenu(true);
        this.localService.setIsContract(false);
        this.localService.setIsMembership(true);
        this.localService.setRouteName("mem-policy-violation");
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }

    ngOnInit() {
        this.policyViolationForm = this.preparePolicyViolationForm()

    }

    preparePolicyViolationForm() {
        return this.fb.group({
            feeNotes: [''],
            lateArrivalTime: [''],
            feeAmount: [''],
            totalFeePaidByMember: [''],
            totalFeeDueByMember: [''],
            noPolicyViolationFound: [false],
            warningIssued: [false],
            feeDate: [''],
            feeTypeID: [''],
            caseOwnerId: [''],
            contactId: [0]
        })
    }

    ngAfterViewInit() {
        this.encryptedUser = localStorage.getItem("token");
        if (this.encryptedUser) {
            this.authenticateR().then(() => {
                if (this.user) {
                    this.policyViolationID = this._route.snapshot.queryParams.policyViolationID ? +this._route.snapshot.queryParams.policyViolationID : 0;
                    this.contactId = this._route.snapshot.queryParams.contactId ? +this._route.snapshot.queryParams.contactId : 0;
                    if (this.policyViolationID > 0 || this.contactId > 0) {
                        this.memPolicyViolation_Get();
                        this.membership_GetByContactID(this.contactId)
                    }
                    this.loadData()
                }
                else {
                    this._router.navigate(['/unauthorized']);
                }
            });
        }
        else {
            this._router.navigate(['/unauthorized']);
        }
    }

    async loadData() {
        this.teamSub = this._teamOfficeService.curTeam.pipe(takeUntil(this.destroy$)).subscribe(async (data: any) => {
            if (data != 0 && data != null) {
                this.curTeam = data
                if (this.curTeam?.teamCode > 0) {
                    await this.CMClub_Get();
                    await this.siteSearch();
                    await this.cLPUserGetListByTeamCode(this.user?.cLPCompanyID, this.curTeam?.teamCode);
                    await this.memContactDDget();
                    this.memPolicyViolation_GetList();
                    this.feeTypeDD = this.localService.refMem_GetAllResponse.ref_MemFeeType_List;
                }
            }
            else {
                this.curTeam = JSON.parse(localStorage.getItem("curTeam") || "{}")
                if (this.curTeam?.teamCode > 0) {
                    await this.CMClub_Get();
                    await this.siteSearch();
                    await this.cLPUserGetListByTeamCode(this.user?.cLPCompanyID, this.curTeam?.teamCode);
                    this.memContactDDget();
                    this.memPolicyViolation_GetList();
                    this.feeTypeDD = this.localService.refMem_GetAllResponse.ref_MemFeeType_List;
                }
            }
        })
    }

    async CMClub_Get() {
        if (this.curTeam?.teamCode > 0) {
            this.showSpinner = true
            await this.clubService.CMClub_Get(this.encryptedUser, this.user?.cLPCompanyID, this.curTeam?.teamCode).
                then(async (result: CMClubResponse) => {
                    if (result) {
                        let response = UtilityService.clone(result);
                        this.clubConfig = response?.clubConfig
                    }
                    this.showSpinner = false
                })
                .catch((err: HttpErrorResponse) => {
                    this.showSpinner = false
                    this._globalService.error("site-fields.clubConfigGet", err.message, null,
                    );
                    this._utilityService.handleErrorResponse(err);
                });
        }
    }


    async siteSearch() {
        if (this.clubConfig?.clubId > 0) {
            await this.clubService.siteSearch(this.encryptedUser, 0, this.clubConfig?.clubId, 0, 0).
                then(async (result: CMSiteListResponse) => {
                    if (result) {
                        let response = UtilityService.clone(result);
                        this.sites = response?.sites;
                        this.sites.unshift({
                            siteID: 0,
                            clubID: 0,
                            class1Code: 0,
                            clpcompanyID: 0,
                            siteName: "--Select--",
                            teamCode: 0,
                            address: "",
                            city: "",
                            state: "",
                            country: "",
                            zip: "",
                            taxRate: 0,
                            scheduleSiteVisitURL: "",
                            scheduleOpenHouseURL: "",
                            vesselsURL: "",
                            kioskURL: "",
                            lnkCustom1URL: "",
                            lnkCustom2URL: "",
                            lnkCustom3URL: "",
                            lnkCustom4URL: "",
                            lnkCustom5URL: "",
                            mktCustomText1: "",
                            mktCustomText2: "",
                            mktCustomText3: "",
                            mktCustomText4: "",
                            mktCustomText5: "",
                            mktMultiText1: "",
                            mktMultiText2: "",
                            mktMultiText3: "",
                            mktMultiText4: "",
                            mktMultiText5: "",
                            engDashCustomMMT1D1: "",
                            engDashCustomMMT1D2: "",
                            engDashCustomMMT1D3: "",
                            engDashCustomMMT1D4: "",
                            engDashCustomMMT1D5: "",
                            engDashCustomMMT1D6: "",
                            engDashCustomMMT1D7: "",
                            engDashCustomMMT1D8: "",
                            engDashCustomMMT1D9: "",
                            engDashCustomMMT1D10: "",
                            dtCreated: "",
                            dtModified: "",
                            newLead: 0,
                            newMember: 0,
                            contractSent: 0,
                            contractOpen: 0,
                            waitingCountersign: 0,
                            memberAdded: 0,
                            contractUpgraded: 0,
                            contractRenewed: 0,
                            memberTerminated: 0,
                            contractExpiration: 0,
                            contactUpdate: 0,
                            referralRequest: 0,
                            teamCodeDisplay: "",
                            class1Display: "",
                            phLocation: "",
                            custom1: '',
                            custom2: '',
                            custom3: '',
                            contractCounts: 0
                        })
                    }
                })
                .catch((err: HttpErrorResponse) => {
                    this._globalService.error("site-fields.clubConfigGet", err.message, null,
                    );
                    this._utilityService.handleErrorResponse(err);
                });
        }
    }

    private async authenticateR() {
        await this._localService.authenticateUser(this.encryptedUser)
            .then(async (result: BCMCLPUser) => {
                if (result) {
                    this.user = UtilityService.clone(result);
                    if (result?.strToken && result?.strToken != '') {
                        this.encryptedUser = result?.strToken;
                    }
                }
            })
            .catch((err: HttpErrorResponse) => {
                this._globalService.error("navMenu.authenticateR", err.message, null);
                this._utilityService.handleErrorResponse(err);
            });
    }

    async memPolicyViolation_GetList() {
        let memPolicyViolationListRequest: MemPolicyViolationListRequest = <MemPolicyViolationListRequest>{};
        memPolicyViolationListRequest.clubId = this.clubConfig?.clubId;
        memPolicyViolationListRequest.dateType = 1;
        memPolicyViolationListRequest.dtEnd = '8/5/2025';
        memPolicyViolationListRequest.dtStart = '8/5/2025';
        memPolicyViolationListRequest.feeTypeID = 1;
        memPolicyViolationListRequest.sites = [1, 2];
        memPolicyViolationListRequest.strdtEnd = '8/5/2025';
        memPolicyViolationListRequest.strdtStart = '8/5/2025';
        memPolicyViolationListRequest.timeFrame = 1;
        memPolicyViolationListRequest.users = [1, 2];
        await this.membershipService.memPolicyViolation_GetList(this.encryptedUser, memPolicyViolationListRequest, this.user?.cLPUserID)
            .then(async (result: MemPolicyViolationResponse) => {
                if (result) {
                    let response = UtilityService.clone(result);
                    this.policyViolationList = response?.violations;
                }
            })
            .catch((err: HttpErrorResponse) => {
                this._globalService.error("contact-task.getLoadUsers", err.message, null,
                );
                this._utilityService.handleErrorResponse(err);
            });
    }

    async memPolicyViolation_Update() {
        let memPolicyViolation: MemPolicyViolation = <MemPolicyViolation>{};
        memPolicyViolation.clpCompanyID = this.user?.cLPCompanyID;
        memPolicyViolation.clpUserID = this.user?.cLPUserID;
        memPolicyViolation.contactID = +this.policyViolationForm.controls.contactId.value;
        memPolicyViolation.contractID = this.memberShip.contractID;
        memPolicyViolation.createdByID = this.memPolicyViolation.createdByID;
        memPolicyViolation.feeAmount = +this.policyViolationForm.controls.feeAmount.value;
        memPolicyViolation.feeDate = this.datePipe.transform(this.policyViolationForm.controls.feeDate.value, 'MM/dd/yyyy');
        memPolicyViolation.feeNotes = this.policyViolationForm.controls.feeNotes.value;
        memPolicyViolation.feeTypeID = +this.policyViolationForm.controls.feeTypeID.value;
        memPolicyViolation.fleetID = 1;         /*missing referance table*/
        memPolicyViolation.lateArrivalTime = this.datePipe.transform(this.policyViolationForm.controls.lateArrivalTime.value, 'MM/dd/yyyy');
        memPolicyViolation.membershipIID = +this.memberShip.incrementalID ? +this.memberShip.incrementalID : this.memPolicyViolation?.membershipIID;
        memPolicyViolation.noPolicyViolationFound = this.policyViolationForm.controls.noPolicyViolationFound.value;
        memPolicyViolation.ownerID = +this.policyViolationForm.controls.caseOwnerId.value;
        memPolicyViolation.policyViolationID = this.policyViolationID > 0 ? this.policyViolationID : this.memPolicyViolation?.policyViolationID;
        memPolicyViolation.reservationID = 1;        /*missing referance table*/
        memPolicyViolation.totalFeeDueByMember = +this.policyViolationForm.controls.totalFeeDueByMember.value;
        memPolicyViolation.totalFeePaidByMember = +this.policyViolationForm.controls.totalFeePaidByMember.value;
        memPolicyViolation.warningIssued = this.policyViolationForm.controls.warningIssued.value;
        await this.membershipService.memPolicyViolation_Update(this.encryptedUser, memPolicyViolation)
            .then(async (result: SimpleResponse) => {
                if (result) {
                    let response = UtilityService.clone(result);
                    Swal.fire({ icon: "success", title: "", html: 'Successfully Update!' });
                    return;
                }
                else {
                    Swal.fire({ icon: "error", title: "", html: 'Some error occurred, Try again.' });
                    return;
                }
            })
            .catch((err: HttpErrorResponse) => {
                this._globalService.error("contact-task.getLoadUsers", err.message, null,
                );
                this._utilityService.handleErrorResponse(err);
            });
    }

    async memPolicyViolation_Delete() {
        Swal.fire({
            title: '',
            text: "Are you sure, You wants to delete?",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Confirm',
            cancelButtonText: 'Cancel',
        }).then(async (result) => {
            if (result.isConfirmed) {
                await this.membershipService.memPolicyViolation_Delete(this.encryptedUser, this.policyViolationID)
                    .then(async (result: SimpleResponse) => {
                        if (result) {
                            let response = UtilityService.clone(result);
                            if (response?.messageBool) {
                                Swal.fire({ icon: "success", title: "", html: 'Successfully update a list.' });
                                this._router.navigate(['/mem-policy-violation-list'])
                            }
                            else {
                                Swal.fire({ icon: "error", title: "", html: 'Some error occurred, Try again.' });
                            }
                        }
                    })
                    .catch((err: HttpErrorResponse) => {
                        this._globalService.error("contact-task.getLoadUsers", err.message, null,
                        );
                        this._utilityService.handleErrorResponse(err);
                    });
            }
        });


    }

    async memPolicyViolation_Get() {
        await this.membershipService.memPolicyViolation_Get(this.encryptedUser, this.policyViolationID, this.contactId)
            .then(async (result: MemPolicyViolation) => {
                if (result) {
                    let response = UtilityService.clone(result);
                    this.memPolicyViolation = response;
                    this.patchMemPolicyViolation();
                }
            })
            .catch((err: HttpErrorResponse) => {
                this._globalService.error("contact-task.getLoadUsers", err.message, null,
                );
                this._utilityService.handleErrorResponse(err);
            });
    }

    patchMemPolicyViolation() {
        this.policyViolationForm.controls.totalFeeDueByMember.setValue(this.memPolicyViolation.totalFeeDueByMember);
        this.policyViolationForm.controls.totalFeePaidByMember.setValue(this.memPolicyViolation.totalFeePaidByMember);
        this.policyViolationForm.controls.feeAmount.setValue(this.memPolicyViolation.feeAmount);
        this.policyViolationForm.controls.lateArrivalTime.setValue(this.memPolicyViolation.lateArrivalTime);
        this.policyViolationForm.controls.feeNotes.setValue(this.memPolicyViolation.feeNotes);
        this.policyViolationForm.controls.feeDate.setValue(this.memPolicyViolation.feeDate);
        this.policyViolationForm.controls.feeTypeID.setValue(this.memPolicyViolation.feeTypeID);
        this.policyViolationForm.controls.noPolicyViolationFound.setValue(this.memPolicyViolation.noPolicyViolationFound);
        this.policyViolationForm.controls.warningIssued.setValue(this.memPolicyViolation.warningIssued);
        this.policyViolationForm.controls.contactId.setValue(this.memPolicyViolation.contactID);
    }

    async memContactDDget() {
        await this.membershipService.memContact_CMMember_GetList_DD(this.encryptedUser, this.user?.cLPCompanyID, this.user?.cLPUserID, this.clubConfig?.clubId)
            .then(async (result: MemContactListDropDown[]) => {
                if (result) {
                    this.memContact_dd = UtilityService.clone(result);

                }
            })
            .catch((err: HttpErrorResponse) => {
                this._globalService.error("mem-pause.memContactDDget", err.message, null,
                );
                this._utilityService.handleErrorResponse(err);
            });
    }


    async onChangeMemContact() {
        await this.membership_GetByContactID(+this.policyViolationForm.controls.contactId.value);
    }

    async membership_GetByContactID(contactId) {
        await this.membershipService.membership_GetByContactID(this.encryptedUser, contactId)
            .then(async (result: Membership) => {
                if (result) {
                    this.memberShip = <Membership>{};
                    this.memberShip = UtilityService.clone(result);
                    if (isNullOrUndefined(this.memberShip)) {
                        Swal.fire({ icon: "error", title: "", html: 'The Contact is Not Subcribe!' });
                    }
                }
            })
            .catch((err: HttpErrorResponse) => {
                this._globalService.error("mem-pause.membership_GetByContactID_DDget", err.message, null,
                );
                this._utilityService.handleErrorResponse(err);
            });
    }

    async cLPUserGetListByTeamCode(clpCompanyId, teamCode) {
        await this.userService.cLPUserGetListByTeamCode(this.encryptedUser, clpCompanyId, teamCode ? teamCode : this.user?.cLPUserID).
            then(async (result: UserDD[]) => {
                if (result) {
                    let response = UtilityService.clone(result);
                    this.clpUsersDD = response
                    this.clpUsersDD.unshift({
                        value: 0,
                        text: "--Select--"
                    })
                }
            })
            .catch((err: HttpErrorResponse) => {
                this._globalService.error("contact-task.getLoadUsers", err.message, null,
                );
                this._utilityService.handleErrorResponse(err);
            });
    }
}
